import {putResolve, takeLeading, select, throttle} from 'redux-saga/effects';

import {ORDER_DATES, ORDER_DATES_FAILURE, ORDER_DATES_REQUEST, ORDER_DATES_SUCCESS} from 'new-constants/api.constants';
import {
	getCurrentAuthSelector, getCurrentDeliveryAddressSelector,
	getCurrentMenuSelector,
	getCurrentOrderLinesSelector,
	getCurrentPurchaseSelector,
	getCurrentRestaurantIdSelector,
	getCurrentServerValuesSelector,
	getDeliveryConditionsSelector, getTipAmountSelector,
} from '../selectors';
import {getCartTotal} from 'helpers/purchase.helper.ts';
import {getCartItems} from 'helpers/order-line.helper.ts';
import {OrderingTypes} from 'new-constants/common.constants';
import {getOrderDates} from 'new-actions/api.actions.ts';

function isOrderTimeNotFetched(orderTime) {
	return !orderTime.restaurantId;
}

function isOrderTimeOutdated(orderTime, currentRestaurantId) {
	return orderTime.restaurantId !== currentRestaurantId;
}

function* getOrderTimeIfNecessary() {
	const state = yield select();
	const {orderTime, appState, connectivity, restaurantList, fetchProgress} = state;

	if (fetchProgress[ORDER_DATES]) {
		return;
	}

	const currentRestaurantId = getCurrentRestaurantIdSelector(state);

	if (
		(isOrderTimeNotFetched(orderTime) || isOrderTimeOutdated(orderTime, currentRestaurantId)) &&
		getCurrentAuthSelector(state) &&
		!!currentRestaurantId &&
		connectivity.isOnline !== false
	) {
		const currentPurchase = getCurrentPurchaseSelector(state);
		const currentOrderLines = getCurrentOrderLinesSelector(state);
		const currentMenu = getCurrentMenuSelector(state);
		const deliveryConditions = getDeliveryConditionsSelector(state);
		const currentDeliveryAddress = getCurrentDeliveryAddressSelector(state);

		yield putResolve(
			getOrderDates(
				currentRestaurantId,
				getCartTotal(
					currentPurchase,
					getCurrentServerValuesSelector(state),
					deliveryConditions,
					getCartItems(currentOrderLines, currentMenu),
					getTipAmountSelector(state)
				),
				state.orderTime.pickupDate,
				currentDeliveryAddress?.zip
			)
		);
	}
}

export const orderTimeUpdaterSaga = function* orderTimeUpdaterSaga() {
	yield throttle(
		2500,
		[action => ![ORDER_DATES_REQUEST, ORDER_DATES_SUCCESS, ORDER_DATES_FAILURE].includes(action.type)],
		getOrderTimeIfNecessary
	);
};
